import { render } from "./GameStatus.vue?vue&type=template&id=09b56f5d&scoped=true&ts=true"
import script from "./GameStatus.vue?vue&type=script&lang=ts"
export * from "./GameStatus.vue?vue&type=script&lang=ts"

import "./GameStatus.vue?vue&type=style&index=0&id=09b56f5d&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b56f5d"]])

export default __exports__